import React from "react";
import DataManager from './DataManager';
import ToolContent from "widgets/mtt-sustainability-tool/js/ToolContent";
import "../index.scss";
import AveragesTable from "widgets/mtt-sustainability-tool/js/AveragesTable";

export default class Tool extends React.Component {

    render() {
        return (
            <div className={'mtt-sustainability-tool'}>
                <div className={'mtt-sustainability-tool__inner page_container'}>
                    <React.Fragment>
                        <DataManager>
                            <ToolContent/>
                            <AveragesTable/>
                        </DataManager>
                    </React.Fragment>
                </div>
            </div>
        );
    }
}